import { render, staticRenderFns } from "./BorcluBilgisiList.vue?vue&type=template&id=240b293a"
import script from "./BorcluBilgisiList.vue?vue&type=script&lang=ts"
export * from "./BorcluBilgisiList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports